<!-- Header -->
<app-alert></app-alert>

<div class="header">
  <div class="header__text animated fadeIn" (click)="showFilter = false">
    <span>{{ "appManagement.applications" | translate }}</span>
    <div class="button_header_section">
      @if ('applications:add' | hasPermissions) {
        <button
          class="btn action_button"
          data-toggle="modal"
          data-target="#createApp"
          >
          <i
            class="fa fa-plus animated slideIn"
          (click)="
            filesToUpload = {};
            fileName = '';
            fileSize = '';
            filesToUpload = '';
            createAppForm.reset()
          "
          ></i>
          {{ "appManagement.addApplication" | translate }}
        </button>
      }
    </div>
  </div>
  <div class="header__search">
    <span class="filter_click" (click)="showFilter = !showFilter">
      <img
        src="../../../../../../assets/icons/Filter-Icon.svg"
        alt="search"
        class="img-fluid"
        />
      <span
        class="filter_text"
        id="dropdownMenuButton"
        (selectstart)="(false)"
        unselectable="on"
        >
        {{ "generic.filterTableBy" | translate }}
      </span>
    </span>
    @if (showFilter) {
      <div
        class="card search-dropdown"
        id="filter__dropdown"
        style="height: 200px"
        >
        <form [formGroup]="searchForm" (ngSubmit)="filter()">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="username" class="search_label">{{
                  "appManagement.appName" | translate
                }}</label>
                <input
                  type="text"
                  class="form-control search_input"
                  formControlName="appName"
                  id="username"
                  />
              </div>
            </div>
          </div>
          <div class="button-section text-right">
            <button
              type="button"
              class="btn button-white"
              (click)="showFilter = false"
              >
              {{ "generic.close" | translate }}
            </button>
            <button type="submit" class="btn button-pink">
              {{ "generic.applyFilters" | translate }}
              @if (isLoading) {
                <div
                  class="spinner-border spinner-border-sm ml-3"
                  role="status"
                  >
                  <span class="sr-only">{{ "generic.loading" | translate }}</span>
                </div>
              }
            </button>
          </div>
        </form>
      </div>
    }
  </div>

  <!-- Reset button -->
  <button class="btn btn-secondary reset-filter" (click)="reset()">
    @if (isRefreshing) {
      <i class="fa fa-refresh fa-fast-spin"></i>
    }
    @if (!isRefreshing) {
      <i class="fa fa-refresh"></i>
    }
    {{ "generic.refresh" | translate }}
  </button>
</div>

<!-- No data -->

<!-- Spinner -->
@if (isLoading) {
  <div class="sbl-circ-path text-center"></div>
}

<!-- Table -->
@if (!isLoading) {
  <div
    class="custom-table animated fadeIn"
    (click)="showFilter = false"
    >
    <div class="">
      <div class="card-body">
        <table class="table table-striped">
          <thead class="thead-dark">
            <tr>
              <th scope="col">{{ "appManagement.appName" | translate }}</th>
              <th scope="col">{{ "oemManagement.oem" | translate }}</th>
              <th scope="col">
                {{ "appManagement.appDisplayName" | translate }}
              </th>
              <th scope="col">{{ "appManagement.appDesc" | translate }}</th>
              <th scope="col">{{ "generic.action" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (datum of allApps; track datum) {
              <tr>
                <td scope="row">{{ datum.appName }}</td>
                <td scope="row">{{ datum.oem.name }}</td>
                <td scope="row">{{ datum.displayName }}</td>
                <td scope="row">{{ datum.appDesc }}</td>
                <td>
                  @if ('applications:update' | hasPermissions) {
                    <button
                      class="btn table_button"
                      (click)="showEdit(datum, datum.appDesc, datum.displayName)"
                      >
                      {{ "generic.edit" | translate }}
                    </button>
                  }
                  @if (selectedApp?.id === datum?.id && isFetchingVersions) {
                    <div
                      class="sbl-circ-path text-center"
                      style="width: 1rem; height: 1rem; margin-left: 1rem"
                    ></div>
                  }
                  <button
                    class="btn table_button"
                    (click)="getAllAppsReport(datum)"
                    >
                    {{ "appManagement.version" | translate }}
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
}

@if (!isLoading && dataCount === 0) {
  <div class="empty-table-data">
    <p>No data found or meets the search criteria</p>
  </div>
}

<!-- Page size -->
<div
  class="text-right mt-4 page_size_section animated fadeIn"
  [hidden]="isLoading"
  >
  <span>{{ "generic.numberOfItems" | translate }}:&nbsp;&nbsp;</span>
  <span> {{ dataCount }} </span>

  <span class="ml-3">{{ "generic.pagesize" | translate }}:</span>
  <form class="inline_select">
    <select
      class="form-control form-control-sm"
      (change)="setPageSize($event)"
      #setPageSizeId
      >
      <option value="10">10</option>
      <option value="20">20</option>
      <option value="30">30</option>
      <option value="40">40</option>
      <option value="50">50</option>
      <option value="100">100</option>
    </select>
  </form>
</div>

<!-- Pagination -->
@if (!isLoading) {
  <div class="paginate mt-2 animated fadeIn">
    <nav aria-label="...">
      @if (!isLoading && allApps) {
        <ul class="pagination">
          @if (pager.startPage !== pager.currentPage) {
            <li
              class="page-item"
              (click)="previousPage()"
              >
              <a class="page-link" tabindex="-1" aria-disabled="true">{{
                "generic.previous" | translate
              }}</a>
            </li>
          }
          @for (page of pager.pages; track page) {
            <li
              class="page-item"
              aria-current="page"
              [ngClass]="{ active: pager.currentPage === page }"
              (click)="getPage(page)"
              >
              <a class="page-link">
                {{ page }} <span class="sr-only">(current)</span></a
                >
              </li>
            }
            @if (pager.endPage !== pager.currentPage) {
              <li
                class="page-item"
                (click)="nextPage()"
                >
                <a class="page-link">{{ "generic.next" | translate }}</a>
              </li>
            }
          </ul>
        }
      </nav>
      <!-- Export button -->
      @if (!isLoading && allApps) {
        <div class="export-button animated fadeIn">
          <button
            type="button"
            class="btn btn-light button-plain-icon"
            (click)="generateCSV()"
            >
            <i class="fa fa-download"></i>
            {{ "generic.downloadAsCsv" | translate }}
          </button>
          @if (isCSVLoading) {
            <div
              class="spinner-border spinner-border-sm ml-3"
              role="status"
              >
              <span class="sr-only">{{ "generic.loading" | translate }}</span>
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- //Add App  -->

  <div
    class="modal animated zoomIn"
    id="createApp"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createAppLabel"
    aria-hidden="true"
    >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <h5 class="modal-title" id="createAppLabel">
            {{ "appManagement.addApplication" | translate }}
          </h5>
          <form [formGroup]="createAppForm">
            @if (userDetails.userRole === 'ROLE_SUPER_ADMIN') {
              <div
                class="form-row"
                >
                <div class="form-group col-md-12">
                  <div class="form-group">
                    <span class="has-float-label">
                      <select
                        class="form-control"
                        id="clientId1"
                        type="text"
                        placeholder=" "
                        formControlName="clientId"
                        >
                        @for (client of clients(); track client) {
                          <option
                            value="{{ client.clientId }}"
                            >
                            {{ client.clientName }}
                          </option>
                        }
                      </select>
                      <label for="clientId1">{{
                        "clientManagement.client" | translate
                      }}</label>
                    </span>
                    @if (
                      createAppForm.get('clientId').errors &&
                      (createAppForm.get('clientId').dirty ||
                      createAppForm.get('clientId').touched)
                      ) {
                      <div
                        class="validation-message"
                        >
                        <span
                          class="validation-message"
                    [hidden]="
                      !createAppForm.get('clientId').hasError('required')
                    "
                          >
                          {{ validationMessage.generic.required }}
                          <br />
                        </span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            <div class="form-row">
              <div class="form-group col-md-12">
                <div class="form-group">
                  <span class="has-float-label">
                    <input
                      class="form-control"
                      id="appDesc1"
                      type="text"
                      placeholder=" "
                      formControlName="appDesc"
                      />
                    <label for="appDesc1">{{
                      "appManagement.appDesc" | translate
                    }}</label>
                  </span>
                  @if (
                    createAppForm.get('appDesc').errors &&
                    (createAppForm.get('appDesc').dirty ||
                    createAppForm.get('appDesc').touched)
                    ) {
                    <div
                      class="validation-message"
                      >
                      <span
                        class="validation-message"
                    [hidden]="
                      !createAppForm.get('appDesc').hasError('required')
                    "
                        >
                        {{ validationMessage.appDesc.required }}
                        <br />
                      </span>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <div class="form-group">
                  <span class="has-float-label">
                    <select
                      class="form-control"
                      id="clientId1"
                      type="text"
                      placeholder=" "
                      formControlName="oemName"
                      >
                      @for (oem of allOem; track oem) {
                        <option value="{{ oem.name }}">
                          {{ oem.name }}
                        </option>
                      }
                    </select>
                    <label for="clientId1">{{
                      "oemManagement.oem" | translate
                    }}</label>
                  </span>
                  @if (
                    createAppForm.get('oemName').errors &&
                    (createAppForm.get('oemName').dirty ||
                    createAppForm.get('oemName').touched)
                    ) {
                    <div
                      class="validation-message"
                      >
                      <span
                        class="validation-message"
                    [hidden]="
                      !createAppForm.get('oemName').hasError('required')
                    "
                        >
                        {{ validationMessage.generic.required }}
                        <br />
                      </span>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="form-row no-padding file-section">
              <label class="side_nav__button" for="appLogoFile">
                <input
                  id="appLogoFile"
                  type="file"
                  (input)="selectLogo($event)"
                  />
                <span class="inner_sn">
                  @if (logoName !== '') {
                    <span>
                      <span style="min-width: 100%">
                        <i class="fa fa-file" style="margin-right: 0.9rem"> </i
                          >{{ logoName | titlecase }}
                        </span>
                      </span>
                    }
                    @if (logoName === '') {
                      <span>
                        <i class="fa fa-file" style="margin-right: 0.9rem"> </i>
                        {{ "appManagement.appLogo" | translate }}...
                      </span>
                    }
                  </span>
                </label>
              </div>
              <div class="form-row no-padding file-section">
                <label class="side_nav__button" for="input-file1">
                  <input
                    id="input-file1"
                    type="file"
                    (input)="onSelectedFile($event)"
                    />
                  <span class="inner_sn">
                    @if (fileName !== '') {
                      <span>
                        <span style="min-width: 100%">
                          <i class="fa fa-file" style="margin-right: 0.9rem"> </i
                            >{{ fileName | titlecase }}
                            @if (fileSize) {
                              <span class="ml-1">({{ fileSize }})</span>
                            }
                          </span>
                        </span>
                      }
                      @if (fileName === '') {
                        <span>
                          <i class="fa fa-file" style="margin-right: 0.9rem"> </i>
                          {{ "appManagement.uploadApp" | translate }}...
                        </span>
                      }
                    </span>
                  </label>
                </div>
                @if (!isAppCreating || uploadProgress === 0) {
                  <div
                    class="form_actions"
                    >
                    <button
                      class="cancel_button"
                      data-dismiss="modal"
              (click)="
                createAppForm.reset();
                fileName = '';
                fileSize = '';
                cancelUpload()
              "
                      >
                      {{ "generic.cancel" | translate }}
                    </button>
                    @if (!isAppCreating) {
                      <button
                        class="btn action_button"
                        (click)="createApp()"
                        [disabled]="!createAppForm.valid || fileName === ''"
                        >
                        <i class="fa fa-plus animated slideIn"></i>
                        {{ "appManagement.addApplication" | translate }}
                      </button>
                    }
                    @if (isAppCreating && uploadProgress === 0) {
                      <div
                        class="spinner-border spinner-border-sm ml-3"
                        role="status"
                        >
                        <span class="sr-only">{{ "generic.loading" | translate }}</span>
                      </div>
                    }
                  </div>
                }
                @if (isAppCreating && uploadProgress > 0) {
                  <div
                    class="form_actions w-100 upload-progress-container"
                    >
                    <div class="flex-grow-1 upload-progress-bar-wrapper">
                      <div class="progress upload-progress-bar">
                        <div
                          class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                          role="progressbar"
                          [style.width.%]="uploadProgress"
                          [attr.aria-valuenow]="uploadProgress"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      <small class="text-muted d-block text-left mt-1"
                        >{{ uploadProgress }}% Uploaded</small
                        >
                      </div>
                      <button
                        class="cancel_button"
                        data-dismiss="modal"
              (click)="
                createAppForm.reset();
                fileName = '';
                fileSize = '';
                cancelUpload()
              "
                        >
                        {{ "generic.cancel" | translate }}
                      </button>
                    </div>
                  }
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- Warn User -->
        <div
          class="modal animated zoomIn"
          id="confirmationModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="confirmationModal"
          aria-hidden="true"
          style="z-index: 99999"
          >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div
              class="modal-content"
              style="min-height: 7rem !important; border: 1px solid lightgray"
              >
              <div class="modal-body">
                <h5 class="modal-title" id="confirmationModal"></h5>
                <span class="modal_subtitle">
                  {{ "generic.aboutToDelete" | translate }}
                  @if (selectedValue) {
                    <b> {{ selectedValue.appVersionName }} </b>
                  }
                </span>
                <div class="form_actions">
                  <div class="cancel_button" data-dismiss="modal">
                    {{ "generic.cancel" | translate }}
                  </div>
                  @if (isDeleting) {
                    <div
                      class="spinner-border spinner-border-sm ml-3"
                      role="status"
                    ></div>
                  }
                  @if (!isDeleting) {
                    <button
                      class="btn action_button"
                      (click)="deleteApp()"
                      >
                      {{ "generic.yes" | translate }}
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- //Edit User  -->
        <div
          class="modal animated zoomIn"
          id="editApp"
          tabindex="-1"
          role="dialog"
          aria-labelledby="editAppLabel"
          aria-hidden="true"
          >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <h5 class="modal-title" id="editAppLabel">
                  {{ "appManagement.editApplication" | translate }}
                </h5>
                <form [formGroup]="editAppForm">
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <div class="form-group">
                        <span class="has-float-label">
                          <input
                            class="form-control"
                            id="appName1"
                            type="text"
                            placeholder=" "
                            formControlName="appName"
                            />
                          <label for="appName1">{{
                            "appManagement.appName" | translate
                          }}</label>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <div class="form-group">
                        <span class="has-float-label">
                          <input
                            class="form-control"
                            id="appDesc"
                            type="text"
                            placeholder=" "
                            formControlName="appDesc"
                            />
                          <label for="appDesc">{{
                            "appManagement.appDesc" | translate
                          }}</label>
                        </span>
                        @if (
                          editAppForm.get('appDesc').errors &&
                          (editAppForm.get('appDesc').dirty ||
                          editAppForm.get('appDesc').touched)
                          ) {
                          <div
                            class="validation-message"
                            >
                            <span
                              class="validation-message"
                              [hidden]="!editAppForm.get('appDesc').hasError('required')"
                              >
                              {{ validationMessage.appDesc.required }}
                              <br />
                            </span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <div class="form-group">
                        <span class="has-float-label">
                          <input
                            class="form-control"
                            id="displayName"
                            type="text"
                            placeholder=" "
                            formControlName="displayName"
                            />
                          <label for="displayName">{{
                            "appManagement.appDisplayName" | translate
                          }}</label>
                        </span>
                        @if (
                          editAppForm.get('displayName').errors &&
                          (editAppForm.get('displayName').dirty ||
                          editAppForm.get('displayName').touched)
                          ) {
                          <div
                            class="validation-message"
                            >
                            <span
                              class="validation-message"
                    [hidden]="
                      !editAppForm.get('displayName').hasError('required')
                    "
                              >
                              {{ validationMessage.displayName.required }}
                              <br />
                            </span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <div class="form-group">
                        <span class="has-float-label">
                          <input
                            class="form-control"
                            id="platformId"
                            type="text"
                            placeholder=" "
                            formControlName="platformId"
                            />
                          <label for="platformId">{{
                            "appManagement.platformId" | translate
                          }}</label>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <div class="form-group">
                        <span class="has-float-label">
                          <select
                            class="form-control"
                            id="clientId1"
                            type="text"
                            placeholder=" "
                            formControlName="oemName"
                            >
                            @for (oem of allOem; track oem) {
                              <option value="{{ oem.name }}">
                                {{ oem.name }}
                              </option>
                            }
                          </select>
                          <label for="clientId1">{{
                            "oemManagement.oem" | translate
                          }}</label>
                        </span>
                        @if (
                          editAppForm.get('oemName').errors &&
                          (editAppForm.get('oemName').dirty ||
                          editAppForm.get('oemName').touched)
                          ) {
                          <div
                            class="validation-message"
                            >
                            <span
                              class="validation-message"
                              [hidden]="!editAppForm.get('oemName').hasError('required')"
                              >
                              {{ validationMessage.generic.required }}
                              <br />
                            </span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  @if (userDetails.userRole === 'ROLE_SUPER_ADMIN') {
                    <div
                      class="form-row"
                      >
                      <div class="form-group col-md-12">
                        <div class="form-group">
                          <span class="has-float-label">
                            <select
                              class="form-control"
                              id="clientId1"
                              type="text"
                              placeholder=" "
                              formControlName="clientId"
                              >
                              @for (client of clients(); track client) {
                                <option
                                  value="{{ client.clientId }}"
                                  >
                                  {{ client.clientName }}
                                </option>
                              }
                            </select>
                            <label for="clientId1">{{
                              "clientManagement.client" | translate
                            }}</label>
                          </span>
                          @if (
                            editAppForm.get('clientId').errors &&
                            (editAppForm.get('clientId').dirty ||
                            editAppForm.get('clientId').touched)
                            ) {
                            <div
                              class="validation-message"
                              >
                              <span
                                class="validation-message"
                                [hidden]="!editAppForm.get('clientId').hasError('required')"
                                >
                                {{ validationMessage.generic.required }}
                                <br />
                              </span>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  <div class="form_actions">
                    <div
                      class="cancel_button"
                      data-dismiss="modal"
              (click)="
                editAppForm.reset();
                editing = '';
                fileName = '';
                fileSize = '';
                isAppCreating = false
              "
                      >
                      {{ "generic.cancel" | translate }}
                    </div>
                    @if (!isAppCreating) {
                      <button
                        class="btn action_button"
                        (click)="updateAppDetails()"
                        [disabled]="!editAppForm.valid"
                        >
                        <i class="fa fa-plus animated slideIn"></i>
                        {{ "appManagement.uploadApp" | translate }}
                      </button>
                    }
                    @if (isAppCreating) {
                      <div
                        class="spinner-border spinner-border-sm ml-3"
                        role="status"
                        >
                        <span class="sr-only">{{ "generic.loading" | translate }}</span>
                      </div>
                    }
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- View Versions -->
        @if (selectedApp) {
          <div
            class="modal animated zoomIn"
            id="showVersions"
            tabindex="-1"
            role="dialog"
            aria-labelledby="showVersionsLabel"
            aria-hidden="true"
            >
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content" style="min-width: 45em">
                <div class="modal-body">
                  <h5 class="modal-title" id="showVersionsLabel">
                    <span>
                      {{ "appManagement.version" | translate }}
                      {{ "generic.of" | translate }} {{ selectedApp.appName }}
                    </span>
                    <span>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </span>
                  </h5>
                  @if ('applications:add' | hasPermissions) {
                    <span
                      class="modal-subtitle"
                      >
                      <span
                        class="subtitle-link"
            (click)="
              showVersionForm = !showVersionForm;
              newVersionForm.reset();
              fileName = '';
              fileSize = '';
              filesToUpload = {}
            "
                        >
                        {{ "appManagement.addNewVersion" | translate }}
                      </span>
                    </span>
                  }
                  @if (showVersionForm) {
                    <span class="form_area">
                      <form [formGroup]="newVersionForm" [@enterAnimation]>
                        <div class="form-row no-padding file-section">
                          <label class="side_nav__button" for="input-file1">
                            <input
                              id="input-file1"
                              type="file"
                              (input)="onSelectedFile($event)"
                              />
                            <span class="inner_sn">
                              @if (fileName !== '') {
                                <span>
                                  <span style="min-width: 100%">
                                    <i class="fa fa-file" style="margin-right: 0.9rem"> </i
                                      >{{ fileName | titlecase }}
                                      @if (fileSize) {
                                        <span class="ml-1"
                                          >({{ fileSize }})</span
                                          >
                                        }
                                      </span>
                                    </span>
                                  }
                                  @if (fileName === '') {
                                    <span>
                                      <i class="fa fa-file" style="margin-right: 0.9rem"> </i>
                                      {{ "appManagement.uploadApp" | translate }}...
                                    </span>
                                  }
                                </span>
                              </label>
                            </div>
                            <div class="form-row no-padding file-section">
                              <label class="side_nav__button" for="appLogoFile">
                                <input
                                  id="appLogoFile"
                                  type="file"
                                  (input)="selectLogo($event)"
                                  />
                                <span class="inner_sn">
                                  @if (logoName !== '') {
                                    <span>
                                      <span style="min-width: 100%">
                                        <i class="fa fa-file" style="margin-right: 0.9rem"> </i
                                          >{{ logoName | titlecase }}
                                        </span>
                                      </span>
                                    }
                                    @if (logoName === '') {
                                      <span>
                                        <i class="fa fa-file" style="margin-right: 0.9rem"> </i>
                                        {{ "appManagement.appLogo" | translate }}...
                                      </span>
                                    }
                                  </span>
                                </label>
                              </div>
                              @if (!isAppCreating || uploadProgress === 0) {
                                <div
                                  class="form_actions"
                                  >
                                  <button
                                    class="cancel_button"
                                    data-dismiss="modal"
                (click)="
                  newVersionForm.reset();
                  fileName = '';
                  fileSize = '';
                  cancelUpload()
                "
                                    >
                                    {{ "generic.cancel" | translate }}
                                  </button>
                                  @if (!isAppCreating) {
                                    <button
                                      class="btn action_button"
                                      (click)="updateAppDetailsWithUpload()"
                                      [disabled]="!newVersionForm.valid || fileName === ''"
                                      >
                                      <i class="fa fa-plus animated slideIn"></i>
                                      {{ "generic.add" | translate }}
                                    </button>
                                  }
                                  @if (isAppCreating && uploadProgress === 0) {
                                    <div
                                      class="spinner-border spinner-border-sm ml-3"
                                      role="status"
                                      >
                                      <span class="sr-only">{{ "generic.loading" | translate }}</span>
                                    </div>
                                  }
                                </div>
                              }
                              @if (isAppCreating && uploadProgress > 0) {
                                <div
                                  class="form_actions w-100 upload-progress-container"
                                  >
                                  <div class="flex-grow-1 upload-progress-bar-wrapper">
                                    <div class="progress upload-progress-bar">
                                      <div
                                        class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                                        role="progressbar"
                                        [style.width.%]="uploadProgress"
                                        [attr.aria-valuenow]="uploadProgress"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                      ></div>
                                    </div>
                                    <small class="text-muted d-block text-left mt-1"
                                      >{{ uploadProgress }}% Uploaded</small
                                      >
                                    </div>
                                    <button
                                      class="cancel_button"
                                      data-dismiss="modal"
                (click)="
                  newVersionForm.reset();
                  fileName = '';
                  fileSize = '';
                  cancelUpload()
                "
                                      >
                                      {{ "generic.cancel" | translate }}
                                    </button>
                                  </div>
                                }
                              </form>
                            </span>
                          }
                          @if (!isLoading) {
                            <div class="custom-table animated fadeIn">
                              <div class="">
                                <div class="card-body">
                                  <table class="table table-striped">
                                    <thead class="thead-dark">
                                      <tr>
                                        <th scope="col">
                                          {{ "appManagement.versionCode" | translate }}
                                        </th>
                                        <th scope="col">
                                          {{ "appManagement.versionName" | translate }}
                                        </th>
                                        <th scope="col">
                                          {{ "appManagement.appDisplayName" | translate }}
                                        </th>
                                        <th scope="col">{{ "generic.noOfDevice" | translate }}</th>
                                        @if ('applications:delete' | hasPermissions) {
                                          <th
                                            scope="col"
                                            >
                                            {{ "generic.action" | translate }}
                                          </th>
                                        }
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @for (datum of allAppsReports; track datum) {
                                        <tr>
                                          <td scope="row">{{ datum.appVersionCode }}</td>
                                          <td scope="row">{{ datum.appVersionName }}</td>
                                          <td scope="row">{{ datum.displayName }}</td>
                                          <td scope="row">{{ datum.noOfDevices }}</td>
                                          @if ('applications:delete' | hasPermissions) {
                                            <td>
                                              @if (editing === datum.appName) {
                                                <div
                                                  class="sbl-circ-path text-center"
                                                  style="width: 1rem; height: 1rem; margin-left: 1rem"
                                                ></div>
                                              }
                                              <button
                                                class="btn table_button"
                                                (click)="warnUser(datum)"
                                                >
                                                {{ "generic.delete" | translate }}
                                              </button>
                                            </td>
                                          }
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
